module.exports = __webpack_public_path__ + "static/media/cloud-upload.b945c2a7.svg";